import { prependBearerToToken } from './common';

export interface AuthPolicy {
  tokenProvider: () => Promise<string>;
  advertiserId: string;
}

export default class Headers {
  authPolicy: AuthPolicy;

  constructor(authPolicy: AuthPolicy) {
    if (typeof authPolicy.tokenProvider !== 'function') {
      throw Error('tokenProvider must be a function');
    }

    this.authPolicy = authPolicy;
  }

  public async getAuthHeaders(): Promise<Record<string, string>> {
    const token = await this.authPolicy.tokenProvider();

    const authorization = {
      Authorization: prependBearerToToken(token),
    };

    return {
      ...authorization,
      'X-Seek-Advertiser-ID': this.authPolicy.advertiserId,
    };
  }
}
